import { Routes, RouterModule } from '@angular/router';
import { InitService } from './services/init.service';

import { AnalyticsComponent } from './components/analytics/analytics.component';
import { TableEventsComponent } from './components/table-events/table-events.component'
import { SecurityEventComponent } from './components/security-event/security-event.component';
import { TableGatesComponent } from './components/table-gates/table-gates.component';
import { StoreHoursComponent } from './components/store-hours/store-hours.component';

const appRoutes: Routes = [
    { 
        path: '', 
        redirectTo: 'gates', 
        pathMatch: 'full'
    },
    { 
        path: 'gates', 
        component: TableGatesComponent, 
        canActivate: [InitService] 
    },
    { 
        path: 'analytics', 
        component: AnalyticsComponent, 
        canActivate: [InitService] 
    },
    { 
        path: 'securityevents', 
        component: TableEventsComponent, 
        canActivate: [InitService] 
    },
    { 
        path: 'storehours', 
        component: StoreHoursComponent, 
        canActivate: [InitService] 
    },
    { 
        path: 'event/:id', 
        component: SecurityEventComponent, 
        canActivate: [InitService] 
    }
];

export const AppRouting = RouterModule.forRoot(appRoutes); 